import { AsyncPipe } from '@angular/common'
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
} from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, Router } from '@angular/router'

import { debounceTime, distinctUntilChanged, filter, tap, withLatestFrom } from 'rxjs'

import { DestroyDirective } from '~/core/directives'
import { CompanyFacade } from '~/core/features'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-full-edgar-report',
  templateUrl: './full-edgar-report.component.html',
  styleUrl: './full-edgar-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, LoadingComponent],
})
export class FullEdgarReportComponent {
  private readonly activatedRoute = inject(ActivatedRoute)
  private readonly destroyRed = inject(DestroyRef)
  private readonly router = inject(Router)

  readonly companyFacade = inject(CompanyFacade)

  constructor() {
    afterNextRender(() => {
      // TODO: refactor
      this.companyFacade.ticker$
        .pipe(
          filter(ticker => Boolean(ticker)),
          distinctUntilChanged(),
          debounceTime(100), // INFO: To avoid infinite redirect loop
          withLatestFrom(this.companyFacade.forecast$),
          tap(([, forecast]) => {
            if (!forecast?.summary) {
              this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent })
            }
          }),
          filter(([, forecast]) => Boolean(forecast?.summary)),
          tap(([ticker]) => this.companyFacade.getForecastEdgar(ticker!)),
          takeUntilDestroyed(this.destroyRed)
        )
        .subscribe()
    })
  }
}
